import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'

import ReactApexChart from "react-apexcharts";
import '../../css/Charts.css'


class PieChart extends React.Component {
    constructor(props) {
        super(props);


        this.state = {

            series: this.props.series,
            options: {
                chart: {
                    type: 'pie',
                },
                labels: this.props.labels,
                responsive: [{
                    breakpoint: 1000,
                    options: {
                        chart: {
                            width: 380
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },


        };

    }

    render() {

        return (

            <>


                <Card className="CardGraph d-flex justify-content-between pb-0" style={{width: '80%'}}>
                    <Card.Title >

                        <h5 class="text-left" style={{padding: 10}}>
                            {this.props.GraphTitle}
                        </h5>

                    </Card.Title>

                    {/* className="d-flex justify-content-center"> */}

                    <Card.Body>



                        <div className="mixed-chart">
                            <ReactApexChart options={this.state.options} series={this.state.series} type="pie" />
                        </div>

                    </Card.Body>


                </Card>

            </>
        );
    }
}

export default PieChart;